import React, { useEffect, useState } from "react";
import { UploadFile, DownloadPreview, ToDataSource, StartBrowserDownloadUrl } from "../logic/BosFileTransfer";
import * as BosFilesServices from "data/BosWebServices/BosFilesServices";
import WidgetImage from "../../components/WidgetImage";
import ContentLoading from "../../components/ContentLoading";
import * as Constants from "../logic/Constants";
import FileDragAndDrop from "../../components/FileDragAndDrop";

// Externals
import cn from "classnames";

// DevExtreme components
import Button from 'devextreme-react/button';

// Component styles
import classes from "./DMSWidget.module.scss";

export function DMSWidget(props) {
  const { ui, config, data, writeBack, dataSegment } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  let fileInputSelector;

  let widgetId = ui.id;
  let disabled = ui.readonly || (data && data.readonly);

  let content = data && data.content ? JSON.parse(data.content) : "";
  let displayContent = content && content.FileName ? content.FileName : "";
  let valueContent = content && content.FileId ? content.FileId : "";
  let enabledActions = content ? content.EnabledActionIds : null;
  let imageMode = config ? config.ImageMode : null;

  useEffect(() => {
    function fetchData() {
      DownloadPreview(valueContent, dataSegment.authToken)
        .then(result => {
          console.log("DownloadPreview result: ", result);
          let img = ToDataSource(result.content, result.contentType);
          setPreviewImage(img);
        })
        .catch(error => {
          console.error("DownloadPreview result: ", error);
          setPreviewImage();
        });
    }
    //console.log("DMSWidget data of " + ui.id + ": ", data);
    if (valueContent)
      fetchData();
    else
      setPreviewImage();
  }, [data]);

  const handleDocumentClick = (event) => {
    event.preventDefault();
    if (disabled) return;
    let fileId = valueContent;
    if (fileId) {
      console.log("Downloading file", fileId);
      setIsLoading(true);
      let fileUrl = BosFilesServices.getProtectedWebResourceUrl(dataSegment.authToken, fileId);
      StartBrowserDownloadUrl(fileUrl, displayContent);
      setIsLoading(false);
    }
  };

  const handleAttachNewDocumentClick = () => {
    if (disabled) return;
    selectNewDocument();
  };

  const selectNewDocument = () => {
    fileInputSelector.click();
  };

  const handleFileSelected = (event) => {
    event.preventDefault();
    uploadDocument(event.target.files);
  };

  const uploadDocument = (files) => {
    let selectedFile = files ? (files.length > 0 ? files[0] : null) : null;
    if (selectedFile) {
      console.log("Uploading selected file", selectedFile);
      setIsLoading(true);
      UploadFile(selectedFile, dataSegment.authToken, dataSegment.id)
        .then(fileId => {
          console.log("Upload result: ", fileId);
          let value = JSON.stringify({ FileId: fileId });
          writeBack(value, true);
          setIsLoading(false);
        })
        .catch(error => {
          console.error("Upload result: ", error);
          setIsLoading(false);
        });
    }
    else {
      console.log("No file selected -> nothing to upload");
    }
  }

  const isActionAllowed = actionId => {
    return enabledActions.includes(actionId);
  };

  const handleFileDrop = (files) => {
    uploadDocument(files);
  };

  return (
    <div className={classes.dmsWrapper} id={widgetId}>
      <FileDragAndDrop disabled={disabled || !isActionAllowed(Constants.DOCUMENT_WIDGET_UPLOAD_ACTION)} handleDrop={handleFileDrop} style={{ height: "100%", width: "100%" }}>
        <div className={cn(classes.imageWrapper, "dx-texteditor", "dx-editor-outlined")}>
          {isLoading
            ? <ContentLoading />
            : previewImage
              ? <WidgetImage mode={imageMode} src={previewImage} disabled={!isActionAllowed(Constants.DOCUMENT_WIDGET_DOWNLOAD_ACTION)} onClick={handleDocumentClick} />
              : <pre>{displayContent}</pre>
          }
        </div>
      </FileDragAndDrop>
      <div>
        {disabled || !isActionAllowed(Constants.DOCUMENT_WIDGET_UPLOAD_ACTION)
          ? null
          : (
            <Button
              className={classes.button}
              icon="file"
              stylingMode="text"
              onClick={() => handleAttachNewDocumentClick()}
            />
          )
        }
      </div>
      {/* INVISIBLE FILE UPLOAD INPUT */}
      <input type="file" multiple={false} accept="*/*" ref={el => fileInputSelector = el} onChange={(e) => handleFileSelected(e)} style={{ display: "none" }} />
    </div>
  );
}
